<div data-test="EbPj98S_" class="position-relative">
  <div
    data-test="8oIVHZxo"
    [class.show]="showItems"
    [class.active]="showItems"
    class="dropdown dropdown_bottom-right dropdown_arrow"
    id="dd-10"
    style="right: -3px"
  >
    <div data-test="JyE86JjZ" class="dropdown__wrap">
      <ul data-test="R9bwjPzA" class="dropdown__menu">
        <li
          data-test="KSLlsIjS"
          (mousedown)="handleClick($event, status)"
          *ngFor="let status of statusesArray"
          class="dropdown__menu-item"
          [class.checked]="isStatusActive(status)"
        >
          <a data-test="-HLHMbpD" class="dropdown__menu-link">
            <span
              data-test="EKmX-N8P"
              *ngIf="canAddColoredFilter()"
              class="dropdown__item-signal"
              [ngClass]="getFilterColorClass(to(status, 'ProjectStatuses'))"
            ></span>
            <span data-test="fYghrFmB" *ngIf="statusLabelsArray">
              {{ statusLabelsArray[status] }}
            </span>
            <span data-test="csEjQiZM" *ngIf="!statusLabelsArray">
              {{ status | titlecase }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <h2
    data-test="DKGEBzJC"
    [class.active]="showItems"
    class="modules-toolbox__title"
    data-dropdown="#dd-10"
    (mousedown)="toggle($event)"
  >
    <span data-test="iDUFixli" *ngIf="showTotal" class="text-light">{{ total }}</span>
    {{ label }}
    <span data-test="JVWVTBUm" *ngIf="currentStatus !== null || statusLabelsArray">
      ({{ statusLabelForTotals }})
    </span>
    <i data-test="dDIzilal" class="material-icons">keyboard_arrow_down</i>
  </h2>
</div>
